import styled from 'styled-components';

const BrandProductList = styled.div`
  &&& {
    ${({ fontSize }) => `font-size: ${fontSize}`};
  }
  font-family: "Avenir Black", "Arial Black", sans-serif;
  letter-spacing: 1px;
  margin-bottom: 5px;
  margin-top: 8px;
  text-transform: uppercase;
`;

export default BrandProductList;
